import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectDevTools = createSelector(getSystem, ({ devTools }) => devTools);

const selectObLogs = createSelector(selectDevTools, ({ obLogs }) => obLogs);

const selectHttpRequestLogs = createSelector(
  selectDevTools,
  ({ httpRequestLogs }) => httpRequestLogs,
);

export const selectObLogsRawData = createSelector(selectHttpRequestLogs, logs => logs);

export const selectObLogsTotal = createSelector(
  selectDevTools,
  ({ httpRequestLogsTotal }) => httpRequestLogsTotal,
);

export const selectSelectedLogId = createSelector(
  selectObLogs,
  ({ selectedLogId }) => selectedLogId,
);
